export default __webpack_public_path__ + "static/media/brakes.b811f73b.svg";